import { IconLock } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";
import CommunityPlansAvailableTable from "@components/CommunityPlansAvailableTable";

import "./styles.scss";

export default function GroupNoAccess({ communityId, availability }) {
    const { t } = useTranslation("community");

    return (
        <div className="group-no-access">
            <div className="group-no-access__icon">
                <IconLock size={28} />
            </div>
            <Text.h3 contrast={8} className="group-no-access__title">
                {t("group.noAccess.title")}
            </Text.h3>
            <Text.span contrast={4} className="group-no-access__subtitle">
                {t("group.noAccess.subtitle")}
            </Text.span>
            <div className="group-no-access__plans">
                <CommunityPlansAvailableTable
                    communityId={communityId}
                    availability={availability}
                />
            </div>
        </div>
    );
}
